var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 16,
    viewBox: "0 0 82 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_7996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6263 7.40612C71.2077 7.12999 70.7465 6.93366 70.3099 6.68823C70.0267 6.52869 69.725 6.38753 69.4793 6.18504C69.0607 5.84144 69.1468 5.1665 69.5839 4.87195C70.2114 4.45472 71.2508 4.68784 71.3616 5.54079C71.3616 5.55916 71.3801 5.57147 71.3985 5.57147H72.3461C72.3707 5.57147 72.3892 5.55305 72.383 5.52852C72.3338 4.93943 72.106 4.44856 71.6879 4.13562C71.2877 3.83495 70.8326 3.67542 70.3463 3.67542C67.8427 3.67542 67.6149 6.32005 68.9622 7.15457C69.1161 7.25274 70.4387 7.91541 70.9065 8.2038C71.3739 8.49219 71.5217 9.0199 71.3185 9.43714C71.1338 9.81759 70.6541 10.0814 70.1744 10.0508C69.6512 10.0201 69.2453 9.73784 69.1037 9.29603C69.0791 9.21628 69.0668 9.06285 69.0668 8.99537C69.0668 8.97695 69.0483 8.95853 69.0299 8.95853H68.0028C67.9843 8.95853 67.9658 8.97695 67.9658 8.99537C67.9658 9.73784 68.1505 10.1489 68.6548 10.5233C69.1284 10.8791 69.645 11.0264 70.1806 11.0264C71.5832 11.0264 72.3092 10.2348 72.4564 9.41261C72.5857 8.60877 72.3461 7.88473 71.6263 7.40612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0184 3.81042H26.5632H26.0649C26.0464 3.81042 26.0341 3.82269 26.028 3.83497L25.1852 6.60846C25.1729 6.6453 25.1237 6.6453 25.1114 6.60846L24.2686 3.83497C24.2624 3.81656 24.2501 3.81042 24.2316 3.81042H23.7334H23.2781H22.6629C22.6444 3.81042 22.626 3.82883 22.626 3.84724V10.9283C22.626 10.9466 22.6444 10.9651 22.6629 10.9651H23.6903C23.7087 10.9651 23.7272 10.9466 23.7272 10.9283V5.54692C23.7272 5.50397 23.7887 5.49786 23.801 5.53465L24.6499 8.32656L24.7115 8.5229C24.7176 8.54132 24.7299 8.54747 24.7484 8.54747H25.5359C25.5543 8.54747 25.5666 8.53516 25.5727 8.5229L25.6343 8.32656L26.4832 5.53465C26.4955 5.4917 26.557 5.50397 26.557 5.54692V10.9283C26.557 10.9466 26.5755 10.9651 26.5939 10.9651H27.6213C27.6398 10.9651 27.6582 10.9466 27.6582 10.9283V3.84724C27.6582 3.82883 27.6398 3.81042 27.6213 3.81042H27.0184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8956 3.81046C55.8771 3.81046 55.8648 3.82272 55.8587 3.835L55.0162 6.60849C55.0039 6.64533 54.9547 6.64533 54.9424 6.60849L54.0995 3.835C54.0933 3.81659 54.081 3.81046 54.0625 3.81046H52.4998C52.4814 3.81046 52.4629 3.82886 52.4629 3.84727V10.9283C52.4629 10.9467 52.4814 10.9651 52.4998 10.9651H53.5274C53.5459 10.9651 53.5643 10.9467 53.5643 10.9283V5.54695C53.5643 5.504 53.6259 5.49789 53.6382 5.53468L54.4868 8.3266L54.5484 8.52293C54.5545 8.54135 54.5668 8.5475 54.5853 8.5475H55.3728C55.3913 8.5475 55.4036 8.53519 55.4097 8.52293L55.4713 8.3266L56.3204 5.53468C56.3327 5.49173 56.3942 5.504 56.3942 5.54695V10.9283C56.3942 10.9467 56.4127 10.9651 56.4312 10.9651H57.4583C57.4768 10.9651 57.4952 10.9467 57.4952 10.9283V3.84727C57.4952 3.82886 57.4768 3.81046 57.4583 3.81046H55.8956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6447 3.81042H40.7314H39.704H37.7908C37.7724 3.81042 37.7539 3.82883 37.7539 3.84724V4.73081C37.7539 4.74923 37.7724 4.76765 37.7908 4.76765H39.6672V10.9283C39.6672 10.9466 39.6856 10.9651 39.704 10.9651H40.7314C40.7499 10.9651 40.7683 10.9466 40.7683 10.9283V4.76765H42.6447C42.6631 4.76765 42.6815 4.74923 42.6815 4.73081V3.84724C42.6815 3.82883 42.6693 3.81042 42.6447 3.81042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7041 10.965H49.6389C49.6635 10.965 49.682 10.9405 49.6758 10.916L47.7443 3.8104C47.7381 3.79199 47.7258 3.78586 47.7073 3.78586H47.3506H46.7231H46.3663C46.3478 3.78586 46.3355 3.79813 46.3294 3.8104L44.3977 10.916C44.3915 10.9405 44.41 10.965 44.4346 10.965H45.3697C45.3881 10.965 45.4005 10.9528 45.4066 10.9405L45.9664 8.87262C45.9725 8.85425 45.9849 8.84809 46.0033 8.84809H48.0705C48.089 8.84809 48.1013 8.86036 48.1075 8.87262L48.6672 10.9405C48.6733 10.9528 48.6918 10.965 48.7041 10.965ZM46.2494 7.83566L46.9999 5.06827C47.0122 5.03148 47.0615 5.03148 47.0738 5.06827L47.8243 7.83566C47.8304 7.86019 47.812 7.88472 47.7873 7.88472H46.2863C46.2617 7.88472 46.2433 7.86019 46.2494 7.83566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6494 10.965H65.5842C65.6088 10.965 65.6273 10.9405 65.6211 10.916L63.6895 3.8104C63.6834 3.79199 63.6711 3.78586 63.6526 3.78586H63.296H62.6686H62.3115C62.293 3.78586 62.2807 3.79813 62.2746 3.8104L60.343 10.916C60.3368 10.9405 60.3553 10.965 60.3799 10.965H61.3152C61.3336 10.965 61.346 10.9528 61.3521 10.9405L61.9118 8.87262C61.918 8.85425 61.9303 8.84809 61.9488 8.84809H64.0158C64.0343 8.84809 64.0466 8.86036 64.0527 8.87262L64.6125 10.9405C64.6186 10.9528 64.6309 10.965 64.6494 10.965ZM62.1945 7.83566L62.9451 5.06827C62.9574 5.03148 63.0067 5.03148 63.019 5.06827L63.7695 7.83566C63.7757 7.86019 63.7572 7.88472 63.7326 7.88472H62.2315C62.2069 7.88472 62.1884 7.86019 62.1945 7.83566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8297 9.91588V7.71916C31.8297 7.70079 31.8482 7.68237 31.8666 7.68237H34.6042C34.6226 7.68237 34.6411 7.66394 34.6411 7.64552V6.76194C34.6411 6.74357 34.6226 6.72515 34.6042 6.72515H31.8666C31.8482 6.72515 31.8297 6.70672 31.8297 6.6883V4.81071C31.8297 4.79229 31.8482 4.77387 31.8666 4.77387H34.9795C34.9979 4.77387 35.0164 4.75544 35.0164 4.73707V3.85347C35.0164 3.83506 34.9979 3.81665 34.9795 3.81665H31.8297H30.7654C30.747 3.81665 30.7285 3.83506 30.7285 3.85347V4.77387V6.73125V7.68852V9.95883V10.9283C30.7285 10.9467 30.747 10.9652 30.7654 10.9652H31.8297H35.1086C35.1271 10.9652 35.1456 10.9467 35.1456 10.9283V9.99567C35.1456 9.97725 35.1271 9.95883 35.1086 9.95883H31.8605C31.842 9.95272 31.8297 9.94041 31.8297 9.91588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0139 10.9038L77.4581 7.24055C77.4458 7.22828 77.4458 7.20376 77.4581 7.19149L80.6574 3.87801C80.682 3.85347 80.6635 3.81665 80.6327 3.81665H79.3224C79.3101 3.81665 79.304 3.82279 79.2978 3.82892L76.5849 6.63924C76.5603 6.66377 76.5233 6.64535 76.5233 6.61467V3.85347C76.5233 3.83506 76.5049 3.81665 76.4864 3.81665H75.4588C75.4403 3.81665 75.4219 3.83506 75.4219 3.85347V10.9345C75.4219 10.9529 75.4403 10.9713 75.4588 10.9713H76.4864C76.5049 10.9713 76.5233 10.9529 76.5233 10.9345V7.81737C76.5233 7.78669 76.5664 7.76827 76.5849 7.7928L79.6606 10.959C79.6667 10.9652 79.679 10.9713 79.6852 10.9713H80.9955C81.0201 10.9652 81.0386 10.9222 81.0139 10.9038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6073 -6.10352e-05L9.3877 4.60197L10.5443 1.88984L15.6073 -6.10352e-05Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26074 -6.10352e-05L7.42492 4.64492L6.32375 1.88984L1.26074 -6.10352e-05Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3668 10.6705L11.7119 13.1986L15.2554 14.1742L16.2705 10.7258L13.3668 10.6705Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.602539 10.7258L1.61144 14.1742L5.14878 13.1985L3.50007 10.6705L0.602539 10.7258Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95791 6.39979L3.97363 7.88473L7.48019 8.04426L7.36332 4.2706L4.95791 6.39979Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9099 6.39987L9.46768 4.22772L9.3877 8.04434L12.8942 7.88481L11.9099 6.39987Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14844 13.1985L7.27081 12.1738L5.44374 10.7502L5.14844 13.1985Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59668 12.1739L11.7129 13.1986L11.4238 10.7503L9.59668 12.1739Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7129 13.1986L9.59668 12.1739L9.76891 13.5483L9.75044 14.1313L11.7129 13.1986Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14844 13.1985L7.11705 14.1312L7.10474 13.5483L7.27081 12.1738L5.14844 13.1985Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15398 9.84217L5.39453 9.32677L6.6372 8.7561L7.15398 9.84217Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71387 9.84217L10.2306 8.7561L11.4795 9.32677L9.71387 9.84217Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14869 13.1985L5.4563 10.6705L3.5 10.7258L5.14869 13.1985Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4111 10.6705L11.7126 13.1985L13.3674 10.7258L11.4111 10.6705Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8942 7.8847L9.3877 8.04424L9.71373 9.84214L10.2305 8.75602L11.4793 9.32669L12.8942 7.8847Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39471 9.32669L6.63738 8.75602L7.15416 9.84214L7.48019 8.04424L3.97363 7.8847L5.39471 9.32669Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97363 7.8847L5.44394 10.7503L5.39469 9.32669L3.97363 7.8847Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4792 9.32669L11.4238 10.7503L12.8941 7.8847L11.4792 9.32669Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48038 8.04431L7.1543 9.84221L7.56647 11.9652L7.65876 9.16722L7.48038 8.04431Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38712 8.04431L9.21484 9.16112L9.30098 11.9652L9.71315 9.84221L9.38712 8.04431Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71393 9.84223L9.30176 11.9653L9.59706 12.1739L11.4242 10.7503L11.4795 9.32678L9.71393 9.84223Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39453 9.32677L5.44378 10.7503L7.27085 12.1739L7.56615 11.9653L7.15398 9.84222L5.39453 9.32677Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75004 14.1313L9.76846 13.5484L9.60855 13.4134H7.25854L7.10474 13.5484L7.11705 14.1313L5.14844 13.1986L5.83744 13.7631L7.23392 14.7265H9.62697L11.0296 13.7631L11.7125 13.1986L9.75004 14.1313Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59697 12.1738L9.30167 11.9652H7.56684L7.27159 12.1738L7.10547 13.5483L7.25928 13.4133H9.60928L9.76924 13.5483L9.59697 12.1738Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8715 4.90262L16.3945 2.36232L15.607 -6.10352e-05L9.59668 4.44859L11.9097 6.39982L15.1764 7.35093L15.8962 6.5103L15.5825 6.28324L16.0807 5.8292L15.6993 5.53466L16.1976 5.15422L15.8715 4.90262Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.473633 2.36238L1.00269 4.90268L0.664343 5.15428L1.16879 5.53472L0.787379 5.82926L1.28568 6.2833L0.971932 6.51036L1.6917 7.35099L4.95837 6.39988L7.27143 4.44865L1.26107 0L0.473633 2.36238Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1765 7.35092L11.9098 6.39986L12.8941 7.88479L11.4238 10.7503L13.3678 10.7258H16.2715L15.1765 7.35092Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95804 6.39986L1.69142 7.35092L0.602539 10.7258H3.50007L5.44404 10.7503L3.97376 7.88479L4.95804 6.39986Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38688 8.04423L9.59604 4.44848L10.5434 1.88977H6.32324L7.27061 4.44848L7.47978 8.04423L7.55976 9.17325L7.56591 11.9652H9.30074L9.30689 9.17325L9.38688 8.04423Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.118386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_7996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.4494,
    height: 15.1534,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.0d4b8c60b13836700351cda6b4bbe29e.svg";
export { ForwardRef as ReactComponent };